import React from 'react';
const FaCheck = require('react-icons/lib/fa/check');
//const FaCross = require('react-icons/lib/fa/close');

const FieldValidation = React.createClass({
    propTypes: {
        isValid: React.PropTypes.bool,
        hasError: React.PropTypes.bool,
    },

    render() {
        return (
            <div>
                {this.props.isValid ?
                    <div className="question-validation">
                        <FaCheck />
                    </div>
                : null}
            </div>
        );
    }
});

export default FieldValidation;


/** WEBPACK FOOTER **
 ** ./src/components/Fragments/FieldValidation.js
 **/